
import { Component, OnInit } from '@angular/core';
@Component({
    selector: 'prcins-enroll-automatic-payments',
    templateUrl: './enroll-automatic-payment.component.html',
    styleUrls: ['./enroll-automatic-payment.component.css']
  })
export class EnrollAutomaticPaymentComponent implements OnInit{
    ngOnInit() { }
}